export var ApprovalRequestType;
(function (ApprovalRequestType) {
    ApprovalRequestType["create"] = "create";
    ApprovalRequestType["update"] = "update";
    ApprovalRequestType["delete"] = "delete";
    ApprovalRequestType["download"] = "download";
    ApprovalRequestType["upload"] = "upload";
    ApprovalRequestType["checkIn"] = "checkIn";
    ApprovalRequestType["checkout"] = "checkout";
    ApprovalRequestType["share"] = "share";
})(ApprovalRequestType || (ApprovalRequestType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwcm92YWxSZXF1ZXN0VHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcHByb3ZhbC9BcHByb3ZhbFJlcXVlc3RUeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLG1CQVNYO0FBVEQsV0FBWSxtQkFBbUI7SUFDN0Isd0NBQWlCLENBQUE7SUFDakIsd0NBQWlCLENBQUE7SUFDakIsd0NBQWlCLENBQUE7SUFDakIsNENBQXFCLENBQUE7SUFDckIsd0NBQWlCLENBQUE7SUFDakIsMENBQW1CLENBQUE7SUFDbkIsNENBQXFCLENBQUE7SUFDckIsc0NBQWUsQ0FBQTtBQUNqQixDQUFDLEVBVFcsbUJBQW1CLEtBQW5CLG1CQUFtQixRQVM5QiJ9